import instance from './config';

const getLogs = (page = 1, sortDir = 'asc', sortCol = 'created_at') => {
	return instance.get(`/admin/logs?page=${page}&sortDir=${sortDir}&sortCol=${sortCol}`);
};

export {
	getLogs,
}
